export default __webpack_public_path__ + "static/SR USA - Periodo sugerido para su uso - Declaración-6ae6b106931d2dbbd02384e0e0320a37.pdf";